import React from 'react';
import styled from 'styled-components';

const StyledDecoratedImage = styled.div`
  display: flex;
  > div {
    width: 100%;
    position: relative;
    &:after {
      content: '';
      display: block;
      background: ${({ theme }) => theme.global.colors['accent-1']};
      position: absolute;
      right: 0;
      height: 16px;
      width: 75%;
    }
  }
`;

export const DecoratedImage = ({ children }) => {
  return (
    <StyledDecoratedImage>
      <div>{children}</div>
    </StyledDecoratedImage>
  );
};
